import { Button, Text, WarningIcon } from '@viapeople/components'
import { useNavigate, useParams } from 'react-router-dom'

export function CalibrationNotFound() {
	const navigate = useNavigate()
	const { cycleId } = useParams<{ cycleId: string }>()

	return (
		<main className='w-full p-6'>
			<div className='flex items-center justify-center py-8'>
				<div className='text-center'>
					<WarningIcon className='w-12 h-12 mx-auto mb-4 text-gray-400' />
					<Text>Calibration session not found or access denied.</Text>
					<Button className='mt-4' variant='secondary' onClick={() => navigate(`/cycles/${cycleId}`)}>
						Back to Cycle
					</Button>
				</div>
			</div>
		</main>
	)
}
